import { ModuleWithProviders, NgModule } from '@angular/core';
import { GOLIATH_SHAPING_MANAGEMENT_ROUTE_PROVIDERS } from './providers/route.provider';

@NgModule()
export class GoliathShapingManagementConfigModule {
  static forRoot(): ModuleWithProviders<GoliathShapingManagementConfigModule> {
    return {
      ngModule: GoliathShapingManagementConfigModule,
      providers: [GOLIATH_SHAPING_MANAGEMENT_ROUTE_PROVIDERS],
    };
  }
}
